import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const Breadcrumb = ({ routes }) => {
    return (
        <nav aria-label="breadcrumb" id='breadcrumb'>

{/* <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.1875L21.4501 10.275L21.0001 11.625H20.25V20.25H3.75005V11.625H3.00005L2.55005 10.275L12 3.1875ZM5.25005 10.125V18.75H18.75V10.125L12 5.0625L5.25005 10.125Z" fill="#080341"/>
</svg> */}

            <ol className="breadcrumb">
                {routes.map((route, index) => (
                    <li 
                        key={index} 
                        className={`breadcrumb-item ps-0 pe-2 ${index === routes.length - 1 ? 'active' : ''}`}
                    >
                        {index !== routes.length - 1 ? (
                            <Link className='text-decoration-none' to={route.path}>{route.name}</Link>
                        ) : (
                            route.name
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
};

Breadcrumb.propTypes = {
    routes: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            path: PropTypes.string.isRequired
        })
    ).isRequired
};

export default Breadcrumb;
